import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { addDays, addMonths, format, parse, startOfToday } from 'date-fns';
import { IListViewsPlanning } from '@shared/interfaces/list-views-planning';
import { DayPlanning } from '@shared/interfaces/planning/day-planning.interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BookingDialogComponent } from '@shared/components/booking-dialog/booking-dialog.component';
import { environment } from 'src/environments/environment';
import { ApiService } from '@shared/services/api.service';
import { es } from 'date-fns/locale';
import { parseISO } from 'date-fns';
import { PrimeNGConfig } from 'primeng/api';
import { PlanningMeetingsComponent } from './planning-meetings/planning-meetings.component';
import { GeneralPlanningService } from './services/general-planning.service';

@Component({
  selector: 'app-planning-view',
  templateUrl: './planning-view.component.html',
  styleUrls: ['./planning-view.component.scss'],
  providers: [DialogService],
})
export class PlanningViewComponent implements OnInit {
  @ViewChild('filterSelectServices') filterSelectServices!: ElementRef;
  @ViewChildren('rowDate') rows!: QueryList<ElementRef>;
  @ViewChild('tableMonthContainer') tableMonthContainer!: ElementRef;
  @ViewChild('tableDayContainer', { static: false }) tableDayContainer!: ElementRef;
  @ViewChild(PlanningMeetingsComponent)
  planningMeetingsComponent!: PlanningMeetingsComponent;

  spanishLocale: any;

  occupiedCells: boolean[][] = [];
  planningData: DayPlanning[] = [];
  selectedItems: any[] = [];
  currentMonth: number;
  currentYear: number;
  selectedDate: Date = new Date();
  showCalendar: boolean = false;
  canChangeStatusService: boolean = true;
  monthData: any[] = [];
  hourData: any[] = [];
  filteredHourData: any[] = [];
  warehouseItems: any[] = [];
  viewTab: IListViewsPlanning = {
    hours: false,
    days: false,
    months: true,
  };
  activeIndex: number = 0;
  tabs: string[] = ['planning', 'collected'];
  collectedDate: Date = new Date();
  showBtnCalendar: boolean = false;
  ref: DynamicDialogRef | null = null;
  selectedDateService: SelectedDateService[] = []; // Usar el nuevo tipo
  planningGroupNames: string[] = [];
  filteredMonthData: any[] = [];
  listDatesUnavailables: any = [];
  drumsAndItemsByBooking: any[] = [];
  isFirstLoadByHour: boolean = false;
  environment: any = environment;
  refreshInterval: any = null;
  totalParticipants: number = 0;
  totalParticipantsConfirmed: number = 0;
  scrollPositioned: boolean = false;

  constructor(
    private http: HttpClient,
    private primengConfig: PrimeNGConfig,
    private elRef: ElementRef,
    private dialogService: DialogService,
    private apiService: ApiService,
    private generalPlanningService: GeneralPlanningService,
    private cdr: ChangeDetectorRef
  ) {
    const currentDate = new Date();
    this.currentMonth = currentDate.getMonth() + 1;
    this.currentYear = currentDate.getFullYear();
  }

  ngOnInit() {
    this.viewTab = this.generalPlanningService.viewCached;
    this.selectedDate = this.generalPlanningService.datePlanningCached;
    this.collectedDate = this.generalPlanningService.dateCollectedCached;

    let roles = JSON.parse(localStorage.getItem('me') ?? '')?.roles;

    if (roles) {
      if (roles.includes('super-admin') || roles.includes('manager')) {
        this.canChangeStatusService = true;
      } else {
        this.canChangeStatusService = false;
      }
    } else {
      this.canChangeStatusService = false;
    }

    this.initializeOccupiedCells();
    if (this.viewTab['months']) {
      this.loadMonthData();
    } else if (this.viewTab['days']) {
      this.loadHourData();
    }

    this.refreshInterval = setInterval(() => {
      if (this.viewTab['months']) {
        this.loadMonthData();
      } else if (this.viewTab['days']) {
        this.loadHourData();
      }
    }, 15000);
  }

  ngOnDestroy() {
    if(this.tableMonthContainer){
      this.generalPlanningService.scrollMonthPositionCached =
        this.tableMonthContainer.nativeElement.scrollTop;
    }
    if(this.tableDayContainer){
      this.generalPlanningService.scrollDayPositionCached =
        this.tableDayContainer.nativeElement.scrollTop;
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
    if (this.ref) {
      this.ref.close();
    }
  }

  initializeOccupiedCells() {
    this.occupiedCells = this.hourData.map(() =>
      this.planningGroupNames.map(() => false)
    );
  }

  loadMonthData(): void {
    const month = format(this.selectedDate, 'MM');
    const year = format(this.selectedDate, 'yyyy');
    const postData = { month, year };

    this.http
      .post<DayPlanning[]>(`${environment.baseUrl}/planning/month`, postData)
      .subscribe(
        (data) => {
          if (data && Array.isArray(data)) {
            data.forEach((day: any) => {
              if (day.planning_group && Array.isArray(day.planning_group)) {
                day.planning_group.forEach((group: any) => {
                  if (group.group_name && (group.group_name.includes('Parque Multiaventura - T') || group.group_name.includes('Parque Multiaventura - M'))) {
                    group.group_background_color = '#008009';
                    group.group_text_color = '#ffffff';
                  }
                });
              }
            });
          }
          this.monthData = data;
          this.filteredMonthData = data;
          this.filterByService();
          this.populatePlanningGroupNames();
          this.generalPlanningService.datePlanningCached = this.selectedDate;
          this.generalPlanningService.viewCached = this.viewTab;
          // setTimeout(() => this.scrollToCurrentDate(), 1000);
          if(!this.scrollPositioned){
            this.scrollPositioned = true;
            this.goToSpecificScrollPosition();
          }
        },
        (error) => {
          console.error('Error loading month data:', error);
        }
      );
  }

  goToSpecificScrollPosition() {
    setTimeout(() => {
      if (
        this.tableMonthContainer?.nativeElement &&
        this.generalPlanningService.scrollMonthPositionCached > 0
      ) {
        this.tableMonthContainer.nativeElement.scrollTo({
          top: this.generalPlanningService.scrollMonthPositionCached,
          behavior: 'smooth',
        });
      } else {
        this.scrollToCurrentDate();
      }
      if (
        this.tableDayContainer?.nativeElement &&
        this.generalPlanningService.scrollDayPositionCached > 0
      ) {
        this.tableDayContainer.nativeElement.scrollTo({
          top: this.generalPlanningService.scrollDayPositionCached,
          behavior: 'smooth',
        });
      }
    }, 1000);
  }

  loadHourData(): void {
    const date = format(this.selectedDate, 'yyyy-MM-dd');
    this.http.post(`${environment.baseUrl}/planning/day`, { date }).subscribe(
      (data: any) => {
        if (data && Array.isArray(data)) {
          data.forEach((hour: any) => {
            if (hour.planning_group && Array.isArray(hour.planning_group)) {
              hour.planning_group.forEach((group: any) => {
                if (group.group_name && (group.group_name.includes('Parque Multiaventura - T') || group.group_name.includes('Parque Multiaventura - M'))) {
                  group.group_background_color = '#008009';
                  group.group_text_color = '#ffffff';
                }
              });
            }
          });
        }
        this.hourData = data;
        this.filteredHourData = data;
        this.viewTab['days'] = true;
        this.viewTab['months'] = false;
        this.filterByService();
        this.generalPlanningService.datePlanningCached = this.selectedDate;
        this.generalPlanningService.viewCached = this.viewTab;
        if(!this.scrollPositioned){
          this.scrollPositioned = true;
          this.goToSpecificScrollPosition();
        }
      },
      (error) => {
        console.error('Error loading hour data:', error);
      }
    );
  }

  toggeBlockDate(hour: string, groupName: string) {
    let fullDateString = this.getFullDate(hour);
    let isBlocked: boolean = this.getGroupServices(hour, groupName).is_blocked;

    let group = this.getGroupServices(hour, groupName);

    group.is_blocked = !group.is_blocked;

    if (group.is_blocked) {
      this.apiService
        .post('/service/set-date-unavailable', {
          date_time: fullDateString,
          service: groupName,
        })
        .subscribe((response: any) => {});
    } else {
      this.apiService
        .get(`/service/delete-date-unavailable/${fullDateString}/${groupName}`)
        .subscribe((response: any) => {});
    }
  }

  getFullDate(hour: string) {
    let selectedDateString = format(this.selectedDate, 'yyyy-MM-dd', {
      locale: es,
    });

    let selectedHourDate = parse(hour, 'HH:mm', new Date(), {
      locale: es,
    });

    let selectedHourString = format(selectedHourDate, 'HH:mm:ss', {
      locale: es,
    });
    return `${selectedDateString} ${selectedHourString}`;
  }

  initializeSelectedDateServiceByHour() {
    this.selectedDateService = [];
    this.filteredHourData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        this.selectedDateService.push({
          date: this.formatDate(this.selectedDate),
          hour: hour.hour,
          planning_group: group.group_name,
        });
      });
    });
  }

  initializeSelectedDateServiceByMonth() {
    this.selectedDateService = [];
    this.filteredMonthData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        this.selectedDateService.push({
          date: this.formatDate(this.selectedDate),
          hour: hour.hour,
          planning_group: group.group_name,
        });
      });
    });
  }

  selectAllItems() {
    this.http
      .post<any>(`${environment.baseUrl}/planning/aggregated-items`, {
        selections: this.selectedDateService,
      })
      .subscribe(
        (data) => {
          this.totalParticipants = data.total_participants;
          this.totalParticipantsConfirmed = data.total_participants_confirmed;
          this.selectedItems = [];
          this.selectedItems = data.items;
          this.http
            .post<any>(`${environment.baseUrl}/booking/drums-and-items/get`, {
              selections: this.selectedDateService,
            })
            .subscribe((result: any) => {
              console.log('result: ', result);
              this.drumsAndItemsByBooking = result;
            });
        },
        (error) => {
          console.error('Error updating selected items:', error);
        }
      );
  }

  checkSelectedDateService(
    date: string,
    groupName: string,
    hour?: string | boolean
  ): boolean {
    let existsDateHour = false;
    if (hour) {
      existsDateHour = this.selectedDateService.some((dateHour: any) => {
        return (
          dateHour.date == date &&
          dateHour.planning_group == groupName &&
          dateHour.hour == hour
        );
      });
    } else {
      existsDateHour = this.selectedDateService.some((dateHour: any) => {
        return dateHour.date == date && dateHour.planning_group == groupName;
      });
    }
    return existsDateHour;
  }

  loadItemsByMonth(date: string, planningGroup: string, event: any) {
    if (event.target.checked) {
      this.selectedDateService.push({ date, planning_group: planningGroup });
    } else {
      this.selectedDateService = this.selectedDateService.filter(
        (selection) =>
          !(
            selection.date === date &&
            selection.planning_group === planningGroup
          )
      );
    }
    this.selectAllItems();
  }

  loadItemsByHour(
    date: string,
    hour: string,
    planningGroup: string,
    event: any
  ) {
    console.log('selectedDateService: ', this.selectedDateService);

    if (event.target.checked) {
      this.selectedDateService.push({
        date,
        hour,
        planning_group: planningGroup,
      });
    } else {
      this.selectedDateService = this.selectedDateService.filter(
        (selection) =>
          !(
            selection.date === date &&
            selection.hour === hour &&
            selection.planning_group === planningGroup
          )
      );
    }
    this.selectAllItems();
  }

  markOccupiedCells(startIndex: number, colIndex: number, duration: number) {
    for (let i = 0; i < duration; i++) {
      if (this.occupiedCells[startIndex + i]) {
        this.occupiedCells[startIndex + i][colIndex] = true;
      }
    }
  }

  isCellOccupied(rowIndex: number, colIndex: number): boolean {
    return (
      this.occupiedCells[rowIndex] && this.occupiedCells[rowIndex][colIndex]
    );
  }

  hasGroupStartingAt(hour: string, groupName: string): boolean {
    const index = this.hourData.findIndex((h: any) => h.hour === hour);
    if (index === -1) return false;
    return this.hourData[index].planning_group.some(
      (group: any) =>
        this.isFirstHour(group.start_hour, hour) &&
        group.group_name === groupName
    );
  }

  getGroupDuration(hour: string, groupName: string): number {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return 1;
    const group = hourData.planning_group.find((g: any) => {
      return g.group_name === groupName && this.isFirstHour(g.start_hour, hour);
    });
    let duration = group ? group.duration : 1;
    duration = duration * 2;
    // if(duration > 1){
    //   duration = (duration * 2)+1;
    // }else if(duration == 1){
    //   duration = (duration * 2);
    // }

    if (group) {
      const rowIndex = this.hourData.findIndex((h: any) => h.hour === hour);
      const colIndex = this.planningGroupNames.indexOf(groupName);
      this.markOccupiedCells(rowIndex, colIndex, duration);
    }
    return duration;
  }

  getGroupTotalTickets(hour: string, groupName: string): number {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return 0;

    const group = hourData.planning_group.find(
      (g: any) =>
        g.group_name === groupName && this.isFirstHour(g.start_hour, hour)
    );
    return group ? group.total_tickets : 0;
  }

  getGroupServices(hour: string, groupName: string): any {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return { services: [], groups: [], takepoints: [] };
    const group = hourData.planning_group.find(
      (g: any) =>
        g.group_name === groupName && this.isFirstHour(g.start_hour, hour)
    );
    return group || { services: [], groups: [], takepoints: [] };
  }

  isFirstHour(startHour: string, currentHour: string): boolean {
    return startHour === currentHour;
  }

  isPastDate(date: string): boolean {
    let currentDate = startOfToday();
    const targetDate = parseISO(date);
    return (
      targetDate < currentDate &&
      targetDate.toDateString() !== currentDate.toDateString()
    );
  }

  scrollToCurrentDate(): void {
    const firstNonPastRow = this.rows.find((row) => {
      return !row.nativeElement.classList.contains('past-date');
    });
    if (firstNonPastRow && this.tableMonthContainer) {
      firstNonPastRow.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  selectCollectedDateOnCalendar(event: any) {
    this.collectedDate = event;
    this.generalPlanningService.dateCollectedCached = this.collectedDate;
    this.cdr.detectChanges();
  }

  selectDateOnCalendar(event: any) {
    this.selectedDate = event;
    this.selectedDateService = [];
    setTimeout(() => {
      if (this.viewTab['months']) {
        this.loadMonthData();
        // this.planningMeetingsComponent.loadMonthData();
        this.cdr.detectChanges();
      } else if (this.viewTab['days']) {
        this.loadHourData();
        // this.planningMeetingsComponent.loadDayData();
        this.cdr.detectChanges();
      }
    }, 0);
  }

  manageCalendar(event: any) {
    event.preventDefault();
    this.showCalendar = !this.showCalendar;
  }

  onChangeTab(event: any) {
    if (this.tabs[this.activeIndex] == 'planning') {
      console.log('planning');
    } else if (this.tabs[this.activeIndex] == 'collected') {
      console.log('collected');
    }
  }

  resetDateSelector() {
    this.selectedDate = new Date();
    this.viewTab['days'] = false;
    this.viewTab['months'] = true;
    this.loadMonthData();
  }

  moveDate(position: number) {
    if (this.viewTab['months']) {
      this.selectedDate = addMonths(this.selectedDate, position);
      this.loadMonthData();
    }
    if (this.viewTab['days']) {
      this.selectedDate = addDays(this.selectedDate, position);
      this.loadHourData();
    }
  }

  zoomToDay(date: string): void {
    this.selectedDate = parseISO(date);
    this.selectedDateService = [];
    this.isFirstLoadByHour = true;
    this.loadHourData();
  }

  backZoom(): void {
    this.viewTab['days'] = false;
    this.viewTab['months'] = true;
    this.selectedItems = [];
    this.selectedDateService = [];
    this.drumsAndItemsByBooking = [];
    this.loadMonthData();
  }

  filterByService(event?: any): void {
    const selectedService = this.filterSelectServices.nativeElement.value;
    if (selectedService === 'all') {
      this.filteredMonthData = this.monthData;
      this.filteredHourData = this.hourData;
    } else {
      if (this.viewTab['months']) {
        this.filteredMonthData = this.monthData.map((day) => {
          const filteredGroup = day.planning_group.filter(
            (group: any) => group.group_name === selectedService
          );

          return { ...day, planning_group: filteredGroup };
        });
      } else if (this.viewTab['days']) {
        this.filteredHourData = this.hourData.map((hour) => {
          const filteredGroup = hour.planning_group.filter(
            (group: any) => group.group_name === selectedService
          );
          return { ...hour, planning_group: filteredGroup };
        });
      }
    }
    if (this.viewTab['days']) {
      if (this.isFirstLoadByHour) {
        this.initializeSelectedDateServiceByHour();
        this.selectAllItems();
        this.isFirstLoadByHour = false;
      }
    }
    this.filterItemsByService();
  }

  filterItemsByService() {
    const selectedService = this.filterSelectServices.nativeElement.value;

    if (selectedService != 'all') {
      this.selectedDateService = this.selectedDateService.filter(
        (selectedDate: any) => {
          return selectedDate.planning_group == selectedService;
        }
      );
    }
    this.selectAllItems();
  }

  populatePlanningGroupNames(): void {
    const groupNamesSet = new Set<string>();
    this.monthData.forEach((day) => {
      day.planning_group.forEach((group: any) => {
        groupNamesSet.add(group.group_name);
      });
    });
    this.hourData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        groupNamesSet.add(group.group_name);
      });
    });
    this.planningGroupNames = Array.from(groupNamesSet);
  }

  openBookingByDateServiceDialog(
    date: string,
    groupName: string,
    hour?: string
  ) {
    console.log('date', date);
    console.log('groupName', groupName);
    console.log('hour', hour);
    const postData: { date: string; groupName: string; hour?: string } = {
      date,
      groupName,
    };

    if (hour) {
      postData.hour = hour;
      console.log('hour', hour);
    }

    this.http
      .post(`${environment.baseUrl}/planning/bookings`, postData)
      .subscribe((data: any) => {
        console.log('data bookings:', data);
        const header = hour
          ? `Reservas para ${groupName} en ${date} a las ${hour}`
          : `Reservas para ${groupName} en ${date}`;
        this.ref = this.dialogService.open(BookingDialogComponent, {
          data: {
            bookings: data,
          },
          header: header,
          width: '95%',
          // contentStyle: { maxWidth: '900px', width: '95%' }
        });
      });
  }

  formatDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
  }
}

type SelectedDateService = {
  date: string;
  planning_group: string;
  hour?: string;
};
